import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useStore } from 'react-redux';

import { IconWithBadge } from 'mastodon/components/icon_with_badge';
import api from 'mastodon/api';

const UnansweredMentionsCounterIcon = ({ className }) => {
  const store = useStore();
  const [completedIds, setCompletedIds] = useState(new Set());
  const mountedRef = useRef(true);

  const refreshCompleted = () => {
    api(store.getState).get('/api/v1/completed_mentions').then(res => {
      if (!mountedRef.current) return;
      setCompletedIds(new Set(res.data.map(String)));
    }).catch(() => {});
  };

  useEffect(() => {
    mountedRef.current = true;
    refreshCompleted();

    window.addEventListener('unanswered-mentions:completed', refreshCompleted);
    return () => {
      mountedRef.current = false;
      window.removeEventListener('unanswered-mentions:completed', refreshCompleted);
    };
  }, []);

  const notifications = useSelector(state => state.getIn(['notifications', 'items']));
  const statuses = useSelector(state => state.get('statuses'));

  const count = useMemo(() => {
    if (!notifications || !statuses) return 0;

    return notifications.filter(n => {
      if (!n) return false;
      if (n.get('type') !== 'mention') return false;
      const statusId = n.get('status');
      if (!statusId) return false;

      const status = statuses.get(statusId);
      if (!status) return false;
      if (status.get('replies_count') !== 0) return false;

      return !completedIds.has(String(statusId));
    }).size;
  }, [notifications, statuses, completedIds]);

  return <IconWithBadge id='check' count={count} className={className} />;
};

export default UnansweredMentionsCounterIcon;
